import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ArrayUtil, DateUtil, MathUtil } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ExpenseService } from 'src/app/services/expense.service';

@Component({
  selector: 'app-expenses-general-establishment-report',
  templateUrl: './expenses-general-establishment-report.component.html',
  styleUrls: ['./expenses-general-establishment-report.component.scss']
})
export class ExpensesGeneralEstablishmentReportComponent implements OnInit {
  start: any = "";
  end: any = "";
  type = 2;
  category = null;
  loadingChart = true;
  results = [];

  constructor(
    private toastService: ToastrService,
    private expenseService: ExpenseService
  ) {
    var today = new Date(DateUtil.getActualDate());
    this.end = DateUtil.getActualDate().split('T')[0];
    today.setDate(today.getDate() - 30);
    var other = new Date(today);
    var convert = DateUtil.parseDateToMilliseconds(other.toISOString());
    this.start = new Date(convert).toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.updateChart();
  }

  updateChart() {
    this.loadingChart = true;
    document.getElementById("expenses-general-establishment")['innerHTML'] = "";
    this.expenseService.getExpensesGeneralEstablishment(
      DateUtil.parseDateToMilliseconds(this.start),
      DateUtil.parseDateToMilliseconds(this.end)
    ).subscribe({
      next: (response: ResponseObject) => {
        this.loadingChart = false;
        this.results = response.data;
        response.data = ArrayUtil.order(response.data, this.type == 1);
        var total = [];
        var categories = [];
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];
          if (this.type == 0 && element.day == null && element.month == null && element.year == null) {
            categories.push("TOTAL");
          } else if (this.type == 1 && element.day == null && element.month == null && element.year != null) {
            categories.push(element.year);
          } else if (this.type == 2 && element.day == null && element.month != null) {
            categories.push(element.month);
          } else if (this.type == 3 && element.day != null) {
            categories.push(element.day);
          } else {
            continue;
          }
          total.push(element.total);
        }

        const options = {
          chart: {
            height: 350,
            type: total.length > 1 ? 'area' : 'bar'
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          series: [{
            name: 'Total',
            data: total
          }],
          xaxis: {
            type: 'Mes',
            categories: categories,
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return MathUtil.formatCurrency(val);
              }
            }
          
          },
          legend: {
            offsetY: -10,
          }
        }
        const chart = new ApexCharts(
          document.querySelector("#expenses-general-establishment"),
          options
        );
        chart.render();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.loadingChart = false;
      }
    })
  }
}
